import type { CampaignOnboardingSteps } from '../model';

export const stepsMap: Record<
  CampaignOnboardingSteps,
  {
    component: 'CreditCardCompleted' | 'GenericStepCompleted' | 'HolidayStepCompleted';
    iconName: string;
    text: string;
    optional?: boolean;
    tooltipText: {
      pending?: string;
      inProgress?: string;
      done?: string;
    };
  }
> = {
  creditCardCompleted: {
    component: 'CreditCardCompleted',
    iconName: 'add_card',
    text: 'Credit Card',
    tooltipText: {
      pending: 'Please add Credit Card',
      inProgress: 'Your manager is already working on this.',
    },
  },
  targetAreaCompleted: {
    component: 'GenericStepCompleted',
    iconName: 'location_on',
    text: 'Target Area',
    tooltipText: {
      pending: 'Please provide this data to your manager to start working.',
      inProgress: 'Your manager is already working on this.',
    },
  },
  integrationCompleted: {
    component: 'GenericStepCompleted',
    iconName: 'layers',
    text: 'CRM Integration',
    tooltipText: {
      pending: 'Please provide this data to your manager to start working.',
      inProgress: 'Your manager is already working on this.',
    },
  },
  calendarUrlCompleted: {
    component: 'GenericStepCompleted',
    iconName: 'calendar_month',
    text: 'Calendar URL',
    tooltipText: {
      pending: 'Please provide this data to your manager to start working.',
      inProgress: 'Your manager is already working on this.',
    },
  },
  scheduleCompleted: {
    component: 'GenericStepCompleted',
    iconName: 'calendar_month',
    text: 'Schedule',
    tooltipText: {
      pending: 'Please provide this data to your manager to start working.',
      inProgress: 'Your manager is already working on this.',
    },
  },
  holidayScheduleCompleted: {
    component: 'HolidayStepCompleted',
    iconName: 'beach_access',
    text: 'Holiday Schedule',
    optional: true,
    tooltipText: {
      pending:
        'Identify holidays when your office is closed. Your partnerships manager take care of your campaign and you will have limited number of leads on these dates.',
    },
  },
};
